module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/pc/svg/toolbar_add_tool_processon-256625.svg";